/**
 * Generated runtime TestId mirror for frontend/src/features/admin/CreateInboundConnectorDialog.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

export const CreateInboundConnectorDialogTestIds = {
  inboundConnectorTypeSelect: "inbound-connector-type-select",
  inboundCronError: "inbound-cron-error",
  inboundCronInput: "inbound-cron-input",
  inboundCronPreview: "inbound-cron-preview",
  inboundDisplayNameError: "inbound-display-name-error",
  inboundDisplayNameInput: "inbound-display-name-input",
  inboundEnabledSwitch: "inbound-enabled-switch",
  inboundTargetSystemCombobox: "inbound-target-system-combobox",
  inboundTargetSystemError: "inbound-target-system-error"
} as const;
